import NotificationSoundMP3 from './notification-sound.mp3';
export const PlayNotificationSound = async () => {
  try {
    await new Audio(NotificationSoundMP3).play();
  } catch (err) {
    console.log('Interact with the page to enable notification sound');
    // console.log(err);
  }
};
export { HashIcon } from './HashIcon';
export { SendButton } from './SendButton';
export { SideBarLogoXpel } from './SideBarLogoXpel';